/* Gravador de erros da loja. Requer consentimento Shopify e guarda apenas
 * metadados tecnicos, nunca mensagens, stacks, caminhos ou contexto livre.
 * NUNCA rebenta a pagina.
 *
 * Uso:
 *   FlightRecorder.init({ project: "larrysa-shopify", surface: "product" });
 *   // erros nao apanhados + promessas rejeitadas ficam registados sozinhos.
 *   FlightRecorder.record("manual", error); // so metadados tecnicos fechados
 *
 * Destino (escolhido por esta ordem, ou define sink: fn):
 *   1) window.pywebview.api.fr_record(evt)  -> o Python grava no ~/.flightrecorder
 *   2) POST a um url (opcoes.endpoint)
 *   3) localStorage (anel de 200), para extensoes/web sem backend
 */
(function (root) {
  const FR = {
    project: "desconhecido",
    surface: "web",
    sink: null,
    endpoint: null,

    _allowed() {
      try {
        const privacy = root.Shopify && root.Shopify.customerPrivacy;
        if (root.LARRYSA_ANALYTICS_ALLOWED === true && privacy &&
            privacy.analyticsProcessingAllowed() === true) return true;
      } catch (_) {}
      this._purge();
      return false;
    },

    _purge() {
      try {
        localStorage.removeItem("fr:" + this.project);
        localStorage.removeItem("fr:" + ((root.LARRYSA_FR && root.LARRYSA_FR.project) || "larrysa-shopify"));
      } catch (_) {}
    },

    init(opts) {
      if (this._inited) return this;
      this._inited = true;
      Object.assign(this, opts || {});
      window.addEventListener("error", (e) =>
        this.record("window.onerror", e.error, {
          line: e.lineno, col: e.colno,
        }, "critical"));
      window.addEventListener("unhandledrejection", (e) =>
        this.record("promessa_rejeitada", e.reason, {}, "critical"));
      this.record("arranque", null, {}, "info");
      return this;
    },

    record(where, err, context, level) {
      try {
        if (!this._allowed()) return;
        const known = (value, allowed, fallback) => allowed.includes(value) ? value : fallback;
        const position = value => Number.isSafeInteger(value) && value >= 0 && value <= 10000000 ? value : 0;
        const evt = {
          v: 2,
          ts: new Date().toISOString().slice(0, 19),
          project: known(this.project, ["larrysa-shopify"], "desconhecido"),
          surface: known(this.surface, ["web", "page", "product", "collection", "index", "cart", "search", "blog", "article", "404"], "web"),
          level: known(level, ["info", "error", "critical"], "error"),
          where: known(where, ["arranque", "window.onerror", "promessa_rejeitada"], "manual"),
          kind: known(err && err.name, ["Error", "TypeError", "RangeError", "ReferenceError", "SyntaxError", "URIError", "EvalError", "AggregateError"], "Error"),
          context: { line: position(context && context.line), col: position(context && context.col) },
        };
        this._emit(evt);
      } catch (_) { /* nunca rebenta */ }
    },

    _emit(evt) {
      if (!this._allowed()) return;
      if (typeof this.sink === "function") return void this.sink(evt);
      if (root.pywebview && root.pywebview.api && root.pywebview.api.fr_record)
        return void root.pywebview.api.fr_record(evt);
      if (this.endpoint)
        return void fetch(this.endpoint, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify(evt), keepalive: true,
        }).catch(() => {});
      // ultimo recurso: anel em localStorage (extensoes / web sem backend)
      const k = "fr:" + this.project;
      try {
        const saved = JSON.parse(localStorage.getItem(k) || "[]");
        // On each write, drop old-format records and technical entries older than 24 hours.
        const arr = (Array.isArray(saved) ? saved : []).filter(e => e && e.v === 2 && Date.now() - Date.parse(e.ts + "Z") < 86400000);
        arr.push(evt); while (arr.length > 200) arr.shift();
        localStorage.setItem(k, JSON.stringify(arr));
      } catch (_) { try { localStorage.removeItem(k); } catch (_) {} }
    },
  };
  root.FlightRecorder = FR;
  const privacyEvents = root.document || root;
  if (privacyEvents.addEventListener) {
    privacyEvents.addEventListener("visitorConsentCollected", () => FR._allowed());
    privacyEvents.addEventListener("larrysa:privacy", () => FR._allowed());
  }
  FR._allowed();
  if (typeof module !== "undefined" && module.exports) module.exports = FR;
})(typeof window !== "undefined" ? window : globalThis);
